import { TimePeriodGroupBy } from "@edgetier/watchtower-types";
import { FunctionComponent, useState } from "react";
import { defaultContext, ExploreContext } from "./explore-context";
import { IExploreContext } from "./explore-context.types";

interface IProps extends Omit<Partial<IExploreContext>, "setChartGroupBy"> {}

/**
 * A context provider for the explore screen.
 * @param props.children The children that will have access to the Explore context.
 * @param props.context  Context value to to be initialised with the provider.
 */
export const ExploreContextProvider: FunctionComponent<IProps> = ({ children, ...context }) => {
    const [chartGroupBy, setChartGroupByState] = useState(context.chartGroupBy ?? defaultContext.chartGroupBy);
    const setChartGroupBy = (groupBy: TimePeriodGroupBy) => {
        setChartGroupByState(groupBy);
    };

    return (
        <ExploreContext.Provider value={{ ...defaultContext, ...context, chartGroupBy, setChartGroupBy }}>
            {children}
        </ExploreContext.Provider>
    );
};
